// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vSQ4","title":"Info_title__gelnr","links":"Info_links__3i4qF","link":"Info_link__3QmW-","logo":"Info_logo__3mFL7"};